import { useAuth as useOidcAuth } from 'react-oidc-context'

import type { UserOut } from 'src/api/intranet'

import { useCurrentUser } from './useCurrentUser'

type UseAuthResult = {
  user: UserOut | null
  isAuthenticated: boolean
  isLoading: boolean
  onLogout: () => void
}

export const useAuth = (): UseAuthResult => {
  const oidc = useOidcAuth()
  const { data: me } = useCurrentUser()

  const onLogout = () => {
    oidc
      .signoutRedirect({
        post_logout_redirect_uri: `${globalThis.location.origin}/auth/login`
      })
      .catch(() => undefined)
  }

  return {
    user: me ?? null,
    isAuthenticated: oidc.isAuthenticated,
    isLoading: oidc.isLoading,
    onLogout
  }
}
